export const SPECIAL_INITIATIVES = "SPECIAL_INITIATIVES";
export const SPECIALINITIATIVE_BY_TYPE = "SPECIALINITIATIVE_BY_TYPE";
export const SET_SPECIAL_INITIATIVES = "SET_SPECIAL_INITIATIVES" 